export const iconFontAwesomeWritingEraser = (
	<i className="fa-solid fa-eraser"></i>
);
